import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import {
  Organisation,
  OrganisationService,
} from '../../../services/organisation.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-extend-trial-dialog',
  templateUrl: './extend-trial-dialog.component.html',
  styleUrl: './extend-trial-dialog.component.scss',
})
export class ExtendTrialDialogComponent {
  @Input() data: Organisation | undefined = undefined;

  form: FormGroup;

  // filter all past days
  filterFn = (date) => date >= new Date();

  constructor(
    protected dialogRef: NbDialogRef<ExtendTrialDialogComponent>,
    protected organisationService: OrganisationService,
    protected userService: UserService,
    protected fb: FormBuilder,
    protected nbToastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      client_id: [this.data.id],
      end_date: ['', Validators.required],
    });
  }

  async onSubmit() {
    console.log('Submitting form', this.form.value, this.form.valid);
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    // format date to yyyy-MM-dd
    const formattedDate = this.form.value.end_date
      ? this.form.value.end_date.toISOString().split('T')[0]
      : '';

    this.organisationService
      .extendTrial({ ...this.form.value, end_date: formattedDate })
      .subscribe(() => {
        this.nbToastrService.success(
          'Die Testphase wurde erfolgreich verlängert.',
          'Testphase verlängert!'
        );
        this.dialogRef.close();
      });

    // await this.userService
    //   .inviteUser({
    //     ...(this.form.value as any),
    //   })
    //   .subscribe(() => {
    //     setTimeout(() => {
    //       this.nbToastrService.success(
    //         'Der neu hinzugefügte Benutzer sollte nun eine Einladungs E-Mail erhalten haben.',
    //         'Benutzer erfolgreich eingeladen!'
    //       );
    //       this.dialogRef.close();
    //     }, 300);
    //   });
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }
}
